import React, { createContext, useContext, useState, useCallback, useMemo } from "react";

const WaitlistContext = createContext({ open: false, openWaitlist: () => {}, closeWaitlist: () => {} });

export const WaitlistProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openWaitlist = useCallback(() => setOpen(true), [setOpen]);
  const closeWaitlist = useCallback(() => setOpen(false), [setOpen]);
  const value = useMemo(
    () => ({ open, setOpen, openWaitlist, closeWaitlist }),
    [open, openWaitlist, closeWaitlist]
  );
  return (
    <WaitlistContext.Provider value={value}>
      {children}
    </WaitlistContext.Provider>
  );
};

export const useWaitlist = () => useContext(WaitlistContext);
